module.exports = __webpack_public_path__ + "img/Internet satelital.df1b6f0d.png";